module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.invoice) ? _c('div', {
    staticClass: "thankyou-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("ขอบคุณสำหรับการบริจาค")]), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v("ที่ร่วมสร้างโอกาสทางการศึกษาให้กับน้อง ๆ")]), _vm._v(" "), (_vm.promoteLinks) ? _c('div', {
    staticClass: "promo-links"
  }, _vm._l((_vm.promoteLinks), function(link) {
    return _c('div', {
      staticClass: "promo-link-item d-flex justify-content-center",
      class: ("promo-link-item-type-" + (link.type))
    }, [(link.type === 'link') ? [_c('a', {
      staticClass: "btn btn--default btn--white",
      class: link.content.class,
      attrs: {
        "href": link.content.url,
        "target": link.content.target || '_self'
      }
    }, [_c('div', [_c('svg', {
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M19.1212 6H17.0001C17.0001 3.23858 14.7615 1 12.0001 1C9.23865 1 7.00008 3.23858 7.00008 6H4.87898C3.82286 6 2.94876 6.82118 2.88288 7.87525L2.13288 19.8752C2.06092 21.0266 2.97534 22 4.12898 22H19.8712C21.0248 22 21.9392 21.0266 21.8673 19.8752L21.1173 7.87524C21.0514 6.82117 20.1773 6 19.1212 6ZM7.00008 8H4.87898L4.12898 20L19.8712 20L19.1212 8H17.0001V11C17.0001 11.5523 16.5524 12 16.0001 12C15.4478 12 15.0001 11.5523 15.0001 11V8H9.00008V11C9.00008 11.5523 8.55236 12 8.00008 12C7.44779 12 7.00008 11.5523 7.00008 11V8ZM12.0001 3C13.6569 3 15.0001 4.34315 15.0001 6H9.00008C9.00008 4.34315 10.3432 3 12.0001 3Z",
        "fill": "#F6931D"
      }
    })]), _vm._v("\n                      " + _vm._s(link.content.text) + "\n                    ")])])] : _vm._e(), _vm._v(" "), (link.type === 'linked-image') ? [_c('a', {
      class: link.content.link.class,
      attrs: {
        "href": link.content.link.url,
        "target": link.content.link.target || '_self'
      }
    }, [_c('img', {
      attrs: {
        "src": link.content.image.src,
        "alt": link.content.image.alt
      }
    })])] : _vm._e()], 2)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-center block-social-share"
  }, [_c('span', [_vm._v("แชร์การบริจาคของคุณ")]), _vm._v(" "), _c('vue-goodshare-facebook', {
    attrs: {
      "page_url": _vm.$config.MAIN_WEBSITE_URL,
      "title_social": "Facebook",
      "has_icon": ""
    }
  }), _vm._v(" "), _c('share-line-button', {
    attrs: {
      "page_url": _vm.$config.MAIN_WEBSITE_URL,
      "title_social": "Line",
      "has_icon": ""
    }
  })], 1), _vm._v(" "), (_vm.showUploadSlipForm) ? _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (!_vm.showUploadSlipForm) ? _c('div', [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showChequeInfo) ? _c('div', {
    staticClass: "show-note"
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.showUploadSlipForm) ? _c('div', {
    staticClass: "show-uploadslip"
  }, [_c('upload-slip')], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center thankyou-remark"
  }, [_c('p', [_vm._v("อีกสักครู่ คุณจะได้รับอีเมลยืนยันการบริจาคจากทางเรา หากบริจาคด้วยวิธีการโอนเงิน กรุณายืนยันการโอนเงิน จากแบบฟอร์มด้านล่าง หรือจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thankyou-banner text-center hide-md"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../../../assets/img/kids-thankyou@2x.png"),
      "width": "900px",
      "alt": "ขอบคุณ"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thankyou-banner text-center show-md"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../../../assets/img/kids-thankyou-mobile.png"),
      "alt": "ขอบคุณ"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center thankyou-remark"
  }, [_c('p', [_vm._v("อีกสักครู่ คุณจะได้รับอีเมลยืนยันการบริจาคจากทางเรา")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thankyou-banner text-center hide-md"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../../../assets/img/kids-thankyou@2x.png"),
      "width": "900px",
      "alt": "ขอบคุณ"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thankyou-banner text-center show-md"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../../../assets/img/kids-thankyou-mobile.png"),
      "alt": "ขอบคุณ"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "block-primary block shadow radius mb-15 mt-15"
  }, [_c('h2', {
    staticClass: "text-center mb-20"
  }, [_vm._v("การบริจาคผ่านเช็คสั่งจ่าย")]), _vm._v(" "), _c('div', {
    staticClass: "form__item pd-15"
  }, [_c('div', {
    staticClass: "show-note-item"
  }, [_c('strong', [_vm._v("1. เช็คสั่งจ่าย")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("มูลนิธิยุวพัฒน์ เพื่อโครงการร้อยพลังการศึกษา")])]), _vm._v(" "), _c('div', {
    staticClass: "show-note-item"
  }, [_c('strong', [_vm._v("2. จัดส่งเช็คตัวจริงมาตามที่อยู่ด้านล่างนี้")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("\n                ฝ่ายบัญชี"), _c('br'), _vm._v("\n                มูลนิธิยุวพัฒน์"), _c('br'), _vm._v("\n                1 อาคารพรีเมียร์คอร์เปอเรทปาร์ค ถนนศรีนครินทร์ แขวงหนองบอน เขตประเวศ กรุงเทพ 10250\n              ")])])]), _vm._v(" "), _c('p', {
    staticClass: "mw-600"
  }, [_vm._v("เมื่อเจ้าหน้าที่ตรวจสอบความถูกต้องแล้ว ผู้บริจาคจะได้รับอีเมลยืนยันอีกครั้ง จึงจะถือว่าการบริจาค\nเสร็จสมบูรณ์")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c25abbb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/thank-you/base.vue
// module id = 1193
// module chunks = 0